
import { ConflictUnits } from './conflictUnits';
import { ConflictGroups } from './conflictGroups';

export class ConflictItem {
    conflictUnits: ConflictUnits[] = [];
    conflictGroups: ConflictGroups[] = [];
}
